import { render } from "./ImportScreenRow.vue?vue&type=template&id=2448ea3d"
import script from "./ImportScreenRow.vue?vue&type=script&lang=js"
export * from "./ImportScreenRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__